<template>



</template>

<script>
	import {mapGetters, mapActions, mapState} from 'vuex'
	// import CreateClientModal from "./CreateClientModal";
	// import ChooseClient from "./ChooseClient";
	// import ClientTable from "./ClientTable";
	import ClientForPos from "./ClientForPos";
	// import ClientService from "../../services/client.service";
	// import CLientMemberCard from "./ClientMemberCard";
	import Multiselect from 'vue-multiselect'

	export default {
		name: "ClientForPos",
		props: {
			caption: {
				type: String,
				default: 'Employees'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				transactionCollapsed: true,
				seller: null,
				posCurrentDate: '',
				clientIndex: 0,
				active: false,
				item: null,
				keyword: '',
				currentClientMess: "",
				createModal: false,
				logoutModal: false,
				message: '',
				mode: 'create',
				closable: false,
				loading: false,
				unitName: '',
				clientCurrent: '',
				convert: true,
				param: '',
				clientName: '',
				errorMessage: null,
				suspendActive: false,
				savdoType: 'isOptom',
				contrAgent: [],
				selectContrAgent: false,
				newItem: {
					id: null,
					itemId: null,
					itemName: null,
					count: null,
				},
				childModal: false,
				sampleForAttrId: {
					"field": "category.id",
					"value": "",
					"type": "long",
					"option": "EQUALS",
					"orderBy": "desc"
				},
				categoryOptions: {
					items: [],
					value: null
				},
				contragentsLoading: false,
				groupOptions: {
					items: [],
					value: null
				},
			}
		},
		async mounted() {
			// SELLER Action
			this.makeCurrentDateTime();
			await this.getAllSellers(this.keyword)
			this.$store.commit('clients/resetCurrentClient');
			this.getLatestSuspends();
		},
		/** --BEFORE DESTROY HOOK-- **/
		beforeDestroy() {
			this.resetParamForFilter();
		},
		methods: {
			...mapActions('contragents', [
				'fetchContragents',
				'setCurrentPage', // receives currentPage
				'setParamForFilter', // receives fieldObj
				'deleteParamFromFilter', // receives fieldName
				'resetParamForFilter', // receives nothing; just call and it resets the filter
				'deleteContragentStore',
				'createContragentStore',
				'changeFieldsForTable'
			]),
			...mapActions('references', [
				'getReferenceChildren',
			]),
			...mapActions('clients', [
				'getAllClients', 'getClientWithId', 'getAllSellers',
				'getMemberCardStore', 'emptyObjectStore',
				'setCurrentClient', 'emptyObjectClientSidebar'
			]),
			...mapActions('wholesalePos', [
				'getLatestSuspends', 'deleteSuspendStore', 'editForPosDraft'
			]),
			...mapActions(['logout']),
			...mapActions('employees', [
				'getAllSellers'
			]),
			sellerSelected(seller) {
				this.$store.commit('wholesalePos/setSellerName', seller.firstName + ' ' + seller.lastName);
				this.$store.commit('wholesalePos/setSellerId', seller.id);

			},
			resetSeller() {
				this.$store.commit('wholesalePos/setSellerName', '');
			},
			sellerCustomLabel(seller) {
				return seller.firstName + ' ' + seller.lastName + ' - "' + seller.departmentName + '"'
			},
			fetchSeller(keyword) {
				this.getAllSellers(keyword)
			},
			resetCurrentIndex() {
				this.clientIndex = 0;
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			async onOk(itemId) {
				this.onClose(itemId);
				await this.deleteSuspendStore(itemId);
				await this.getLatestSuspends();
				if (this.currentSuspendId == itemId) {
					this.$emit('changeSuspendActive', false);
					this.$emit("searchBarFocus");
					this.$store.commit('wholesalePos/resetState');
					this.$store.commit('wholesalePos/resetSuspendId');
				}

			},
			async closeClientTable(boolean, index) {
				const emptyObject = {};
				await this.emptyObjectStore(emptyObject);
				// this.$store.commit('clients/setCurrentClient');
				this.childModal = boolean;
				this.clientIndex = index;
				await this.$emit('searchBarFocus');
			},
			openCreate() {
				this.createModal = true
			},
			showZReport() {
				this.$emit('showZReport')
			},
			showXReport() {
				this.$emit('showXReport')
			},
			onCLickDraft() {
				this.getLatestSuspends();
			},
			async updateDraft(data) {
				await this.editForPosDraft(data);
				if (data.customerId) {
					await this.getClientWithId(data.customerId);
				} else {
					const emptyObject = {};
					await this.emptyObjectStore(emptyObject);
				}
//				this.clientName = data.customerName;
//				this.$store.commit('clients/resetCurrentClient');
				// Fire.$emit('activeEmit', {suspendActive: true, message: "Bu edit uchun"});
				await this.$emit('changeSuspendActive', true);
				await this.$emit('searchBarFocus');
			},

			fuc(event) {
				if (event.active == true) {
					this.active = true;
					this.message = event.message;
				} else {

					const emptyObject = {};
					this.message = event.message;
					this.active = false;

//					this.emptyObjectClientSidebar(emptyObject);
				}
			},


			filterClientChanged(newVal) {
				ClientService.searchMember(newVal).then(response => {
					this.items = response.data;
				})
			},

			clickOpen() {
				setTimeout(() => {
					this.active = true;
					this.message = "";
				}, 200)
			},
			close() {
				this.createModal = false;
				this.mode = 'create';
				this.item = null;
			},
			makeCurrentDateTime() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				let day = now.getDate();
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				if (month.toString().length == 1) {
					month = '0' + month;
				}
				if (day.toString().length == 1) {
					day = '0' + day;
				}
				if (hour.toString().length == 1) {
					hour = '0' + hour;
				}
				if (minute.toString().length == 1) {
					minute = '0' + minute;
				}
				if (second.toString().length == 1) {
					second = '0' + second;
				}

				this.posCurrentDate = day + '/' + month + '/' + year;
			},
			toggleIsReturn(boolean) {
				this.$store.commit('wholesalePos/setIsReturn', boolean);
				this.$emit('searchBarFocus');
			},
			async sendObjectToParent() {
				let obj = {};
				obj.type = this.savdoType;

				/** -- CLEAR CLIENT -- **/
				await this.$store.commit('clients/resetCurrentClient');

				/** -- CLEAR SELLER -- **/
				this.seller = null;
				this.resetSeller();

				/** -- CLEAR CUSTOM_PROMOTION -- **/
				await this.$store.commit('wholesalePos/setCustomPromotionGeneral', {obj: null});
				if (this.savdoType === 'isOptom') {

					if (this.contrAgent === null || Object.keys(this.contrAgent).length === 0) {
						this.selectContrAgent = true
						await this.$emit('savdoTypeChanged', obj)
					} else {
						obj.cont = this.contrAgent;
						await this.$emit('savdoTypeChanged', obj)
					}
					if (!this.categoryOptions.value) {
						await this.getReferenceChildren('CONTRAGENT_CATEGORY');
						this.categoryOptions = Object.assign({}, this.getCategoryChildren);
					}
				} else {
					this.contrAgent = null;
					await this.$emit('savdoTypeChanged', obj)
				}
			},
			/* CATEGORY FILTER FUNC */
			async categoryFilterChanged(categoryId) {
				let fieldName = 'category.id';
				if (categoryId) {
					this.sampleForAttrId.field = fieldName;
					this.sampleForAttrId.value = categoryId;

					this.deleteParamFromFilter(fieldName);
					let fieldObj = Object.assign({}, this.sampleForAttrId);
					this.setParamForFilter(fieldObj);
				} else {
					if (!this.groupOptions.value) {
						this.resetParamForFilter();
					} else {
						this.deleteParamFromFilter(fieldName);
					}
				}
				// GET FILTERED DATA
				this.contragentsLoading = true;
				await this.fetchContragents('pos');
				this.contragentsLoading = false;
			},
			/* CLEARING FILTER */
			clearCategoryFilter() {
				this.categoryOptions.value = null;
			},
		},
		computed: {
			...mapGetters('clients', [
				'getClients', 'total', 'clients', 'getFromModalMemberCard', 'getCurrentClient', 'getCurrentClientFromModal'
			]),
			...mapGetters('employees', [
				'getSellers'
			]),
			...mapGetters('references', [
				'getCategoryChildren'
			]),
			...mapState('wholesalePos', [
				'latestSuspends', 'currentSuspendId', 'client', 'isReturn'
			]),
			...mapState('contragents', ['contragents']),
			...mapGetters('contragents', [
				'getContragentsForPos'
			]),
			...mapState(['isCashier', 'isManager']),
			computedFields() {
				return [
					{
						key: 'id',
						label: '№',
						'class': 'min-30',
					},
					{
						key: 'saleNumber',
						label: "Чек №",
						'class': 'min-100',
					},
					{
						key: 'saleDate',
						label: 'Дата',
						'class': 'min-130 fixed',
					},
					// {
					// 	key: 'middleName',
					// 	label: this.$t('client.create.middle-name')
					// },
					// {
					// 	key: 'memberCard',
					// 	label: "Member card"
					// },

					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions min-60',

					},

				]
			},
		},
		watch: {
			savdoType: {
				handler(newValue) {
					if (newValue !== null) {
						this.sendObjectToParent()
					}
				}
			},
			contrAgent: {
				handler(newValue) {
					if (newValue !== null) {
						this.selectContrAgent = false
						this.sendObjectToParent()
					} else {
						this.selectContrAgent = true
						this.sendObjectToParent()
					}
				}
			},
			/* WATCHERS FOR FILTER BEGIN */
			'categoryOptions.value': {
				handler(newVal) {
					if (!newVal) {
						this.categoryFilterChanged(null);
					}
					this.contrAgent = null
				}
			},
		},
		components: {
			// CreateClientModal,
			// ChooseClient,
			// ClientTable,
			ClientForPos,
			// CLientMemberCard,
			Multiselect
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
	.header-sidebar {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 100%;
	}

	.header-sidebar h4 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.header-sidebar h4 > button {
		margin-left: 10px;
	}

	.footer-sidebar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	.row {
		margin-left: -18px;
	}

	.footer-sidebar > button {
		border: 0px solid rgba(0, 0, 0, 0) !important;
		border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
		border-radius: 0px !important;
	}

	.clientForPosMultiselect {
		margin-top: 50px;
	}

	.forHeader {
		/*min-height: 337px;*/
		margin-bottom: 5px;
	}

	.forfooter {
		min-height: 133px;
	}

	.card-header .nav-tabs .nav-link {
		padding: 0px;
	}

	.tabs.mytabs .nav-tabs .nav-link.active {
		background-color: #aabbcc !important;
	}

	.card-body {
		padding: 10px;
	}

	.cardBodyClass {
		position: relative;

		#returnButtonDiv {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			margin: 10px;

			button {
				width: 100%;
			}
		}
	}

	.card-header .nav-tabs .nav-link {
		padding: 0 0 0 0;
	}

	.generalTableClass {
		max-height: 9rem;
		overflow-y: scroll;
		overflow-x: scroll;
	}

	@media (min-width: 1620px) {
		.generalTableClass {
			max-height: 13rem;
		}
	}

	/*.mytabs {
		.nav-tabs {
			.nav-item {
				.nav-link.customTabLink {
					padding: 5px;
				}
			}
		}
	}*/
	.customTabLink {
		padding: 5px;
	}

	.takeMinHeight {
		min-height: 39.1% !important;
		transition: min-height 0.25s ease-in !important;
	}

	.saveButton {
		justify-content: center;
		display: flex;
		align-items: center;
	}

	.posSessionButtons {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		button {
			padding: 0 6px 1px;
			font-size: 12px;
			margin-right: 5px;
			line-height: 1.4;
		}
	}

	.clientTitle {
		font-weight: bold;
		font-size: 16px;
	}
</style>
